import { offcanvas } from "./_offcanvas";
import { table_responsive } from "./_table_responsive";
import "./_week-without-driving";

offcanvas();
table_responsive();
